import { View } from "extensions/marionette";
import $ from "jquery";

import { store } from "common/store";
import { showPassword } from "common/helpers/effects";

import { DO_PASSWORD_UPDATE } from "common/actions/authentication";

import loaderTemplate from "common/helpers/horizontal-loader.jst";
import { PasswordView } from "common/components/password";

import loginTemplateFrame from "./templateFrame.jst";
import templateBody from "./forcePassChange.jst";

export const ForcePasswordChangeView = View.extend({
    template: (data) => loginTemplateFrame({
        partial: templateBody,
        ...data
    }),
    ui: {
        form: "#merchant-forcePassChange-form",
        showPassword: ".showPassword",
        button: ".change-password"
    },
    regions: {
        newPasswordCont: ".new-password"
    },
    events: {
        "submit @ui.form": "changePassword",
        "click @ui.showPassword": "showPassword"
    },
    showPassword,
    onFailed(message) {
        this.removeSpinnerFromActionButton();
        $("#login-status").html(message).removeClass("spacer hidden").addClass("alert-danger");
    },
    changePassword(event) {
        event.preventDefault();

        // Return earlier if prev attempt is still pending
        if (this.waiting) {
            return;
        }

        this.addSpinnerToActionButton();
    
        store.dispatch(DO_PASSWORD_UPDATE({
            forgot: true,
            new_password: this.passwordField.get(),
            token: this.getOption("token")
        })).catch((error) => {
            this.onFailed(error.message);
        });
    },

    addSpinnerToActionButton() {
        this.waiting = true;
        const $loading = $(loaderTemplate()).find(".loading-spinner").addClass("white").end();
        this.prevButtonText = this.ui.button.text();
        this.ui.button.html($loading);
    },

    removeSpinnerFromActionButton() {
        if (this.waiting && this.prevButtonText) {
            this.waiting = false;
            this.ui.button.text(this.prevButtonText);
            delete this.prevButtonText;
        }
    },
    
    /**
     * Render pass field
     */
    onAttach() {
        this.passwordField = new PasswordView({
            token: this.getOption("token")
        });
        
        this.listenTo(this.passwordField, "requirements", function(allDone) {
            this.ui.button.prop("disabled", !allDone);
        });
        
        this.showChildView("newPasswordCont", this.passwordField);
        this.passwordField.focus();
    },
    
    /**
     * Destroy all the subviews
     */
    onDestroy() {
        this.passwordField = null;
    }
});
